import TopBanner from 'components/TopBanner'
import { ProblemList } from 'components/TopBanner/OrderTriageTopBanner'
import type { UserFirstLastName, Order } from 'types'

type OrderTopBannerProps = {
  orderId: Order['_id']
  disableOrder: boolean | undefined
  orderLockedBy: UserFirstLastName | undefined
  isReadOnly: boolean | undefined
}

const OrderTopBanner = ({ orderId, disableOrder, orderLockedBy, isReadOnly }: OrderTopBannerProps): JSX.Element => {
  if (!orderId) {
    return <></>
  }

  const problemsWithOrder: string[] = []

  if (isReadOnly) {
    problemsWithOrder.push(`Order is being filled in a third party pharmacy`)
  } else if (disableOrder) {
    problemsWithOrder.push(
      `This order is currently being worked on by ${orderLockedBy?.firstName} ${orderLockedBy?.lastName}`,
    )
  }

  return problemsWithOrder.length ? (
    <TopBanner message="There are problems with this order">
      <ProblemList>
        {problemsWithOrder.map((problem, i) => (
          <li key={i}>{problem}</li>
        ))}
      </ProblemList>
    </TopBanner>
  ) : (
    <></>
  )
}

export default OrderTopBanner
